module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("了解平台")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.  作品有声化平台是什么？")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2.  我能在作品有声化平台做些什么？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("在这里，你可以：")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "490px",
      "height": "119px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_1.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3.  我能在作品有声化平台收获什么？")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("4.  作品有声化平台使用流程")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("Step  1："), _c('router-link', {
    attrs: {
      "to": {
        name: 'helpCenterCopyrighterSignIn'
      }
    }
  }, [_vm._v("入驻平台")]), _c('br'), _vm._v("\n        注册账号，填写个人或机构资料，提交审核。审核通过即代表入驻成功。"), _c('br'), _vm._v("\n        Step  2 : "), _c('router-link', {
    attrs: {
      "to": {
        name: 'helpCenterCopyrightManagement'
      }
    }
  }, [_vm._v("上传作品")]), _c('br'), _vm._v("\n        入驻成功后，进入版权工作台，填写作品信息，并上传作品内容文本。"), _c('br'), _vm._v("\n        Step  3："), _c('router-link', {
    attrs: {
      "to": {
        name: 'helpCenterTaskManagement'
      }
    }
  }, [_vm._v("发布任务")]), _c('br'), _vm._v("\n        当提交作品审核通过后，就可以发布海选任务，招募并选拔主播。\n    ")], 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("5.  平台联系方式")]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        喜马拉雅作品有声化平台"), _c('br'), _vm._v("\n        是作者、出版机构可将自己作品有声化的平台"), _c('br'), _vm._v("\n        也是主播挑选自己喜欢的书籍、文章，发挥特质完成录音制作的平台"), _c('br'), _vm._v("\n        同时，后期制作者可在平台找到优质有声化成品，加以后期制作，让作品熠熠生辉"), _c('br'), _vm._v("\n        最终，三方完成的成品可以在4亿用户的喜马拉雅平台上与用户见面，共享流量与收益"), _c('br'), _c('br'), _vm._v("\n        如果你手中有书，找不到专业的声音录播团队"), _c('br'), _vm._v("\n        如果你有一副好嗓子，却难以找到梦寐以求的主播成长平台"), _c('br'), _vm._v("\n        如果你有一身后期制作本领，确没有优质作品让你大显身手"), _c('br'), _vm._v("\n        喜马拉雅作品有声化平台"), _c('br'), _vm._v("\n        恰好可以给你想要的"), _c('br'), _vm._v("\n        为你提供成长机会，更给你一个多彩的舞台"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("通过作品有声化平台，你能持续获得收益，包括有声作品销售分成以及平台广告收入分成。喜马拉雅FM拥有4亿用户，依托巨大的流量红利，你的纸书、电子书和周边产品等也能一同获利。"), _c('br'), _vm._v("\n        除了收益外，为你演绎有声作品的平台优秀主播，拥有大量的粉丝和专业的播讲实力，能够帮助你收获更多人气和影响力。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("有声化平台官方邮箱：a.plus@ximalaya.com。")]), _c('br'), _vm._v("\n        有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d87f2110!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/helpCenter/CopyrighterAboutPlatform.vue
// module id = 550
// module chunks = 0